module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.results), function(r) {
    return (r.location) ? _c('gmap-marker', {
      key: r.id,
      attrs: {
        "position": r.location,
        "icon": {
          url: r.icon,
          scaledSize: _vm.iconSize,
          anchor: _vm.iconAnchor
        },
        "clickable": true
      },
      on: {
        "click": function($event) {
          _vm.$bus.$emit('toggleDetailedResult', r.id, 'marker')
        }
      }
    }) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03915012"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/Results.vue
// module id = 464
// module chunks = 0